import { DownOutlined } from "@ant-design/icons";
import { useCurrentUser } from "../../../api/hooks/auth";

function WelcomeTopbar() {
  const { data: userData } = useCurrentUser();
  return (
    <div className="flex bg-[#e6f4ff] py-2">
      <p className="flex-grow text-center capitalize">
        Welcome to Cleantec Logistics, {userData?.name}
      </p>
      {/* <div className="flex gap-2 pr-4">
        <p className="text-sm">Open Panel</p>
        <DownOutlined />
      </div> */}
    </div>
  );
}

export default WelcomeTopbar;
